import React, { useEffect, useState } from "react";
import SocketComponent from "service/Socket.service";
import scanningGif from "assets/gifs/scanning.gif";
import loaderGif from "assets/gifs/loader.gif";
import scanIcon from "assets/icons/scan.svg";
import ManualIcon from "assets/icons/manual.svg";
import loaderSuccess from "assets/icons/suc-load.svg";

const loaderTitle = [
  { name: "Reading policy document", time: 27000 },
  { name: "Understanding the policy document", time: 27000 },
  { name: "Generating results", time: 27000 },
  { name: "Creating PDF", time: 27000 },
  { name: "Finishing up", time: 72000 }
];

interface ScanningStatusProps {
  isScanned: boolean;
  step: number;
  setStep: any;
  isManual: boolean;
}

export const ScanningStatus: React.FC<ScanningStatusProps> = ({ isScanned, step, setStep, isManual }) => {
  const [colorStep, setColorStep] = useState(-1);
  useEffect(() => {
    if (step < loaderTitle.length - 1) {
      // Timer for the color change (1 second before the main step change)
      const colorChangeTimer = setTimeout(
        () => {
          setColorStep(step);
        },
        isScanned ? 1000 : loaderTitle[step].time - 1000
      );

      // Main timer to advance the step
      const stepTimer = setTimeout(
        () => {
          setStep(step + 1);
        },
        isScanned ? 2000 : loaderTitle[step].time
      );

      return () => {
        clearTimeout(colorChangeTimer);
        clearTimeout(stepTimer);
      };
    } else if (step === loaderTitle.length - 1) {
      // Ensure the last step also gets the green color
      const lastColorTimer = setTimeout(() => {
        setColorStep(step);
      }, loaderTitle[step].time - 1000);

      return () => clearTimeout(lastColorTimer);
    }
  }, [step, isScanned]);

  useEffect(() => {
    if (step < loaderTitle.length - 1) {
      const timer = setTimeout(
        () => {
          setStep(step + 1);
        },
        isScanned ? 2000 : loaderTitle[step].time
      );

      return () => clearTimeout(timer);
    }
  }, [step, isScanned]);

  return (
    <>
      <SocketComponent />
      {isManual && !isScanned ? (
        <div className="flex flex-col items-center gap-4 py-10 shadow-none md:shadow-shadowAllSide w-auto  md:w-[34.5rem] rounded-[10px]">
          <img src={ManualIcon} alt="Scanning" className="w-[90px] object-contain transition-all duration-500 ease-in-out" />
          <div className="text-center">
            <p className="text-sm md:text-[22px]  font-extrabold">We are working to analyze your policy</p>
            <p className="text-xs md:text-base font-semibold pt-1">We shall notify you within 1 working day</p>
          </div>
        </div>
      ) : (
        <div className="flex flex-col items-center gap-4 shadow-none md:shadow-shadowAllSide w-auto  md:w-[34.5rem] rounded-[10px]">
          {isScanned && step == 4 ? (
            <div className="relative flex-shrink-0 transition-all duration-500 ease-in-out py-4 md:py-10 flex justify-center flex-col">
              <img src={scanIcon} alt="Scanning" className=" object-contain transition-all duration-500 ease-in-out" />
              <p className="text-lg md:text-xl font-extrabold pt-2 transition-all duration-500 ease-in-out">Results Available</p>
            </div>
          ) : (
            <>
              <img src={scanningGif} alt="Scanning" className="w-[140px] object-contain transition-all duration-500 ease-in-out" />
              <div className="relative h-40 flex flex-col items-center justify-center overflow-hidden pt-5 md:pt-3">
                <div className="transition-all duration-700 ease-in-out" style={{ transform: `translateY(-${step * 2.25}rem)` }}>
                  {loaderTitle.map((item, index) => {
                    const opacityClass = index === step ? "opacity-100" : "opacity-50";
                    const textColorClass = colorStep === index ? "text-green-500" : step === index ? "text-black" : "text-gray-400";
                    const scaleClass = index === step ? "scale-110" : "scale-100";

                    return (
                      <div key={index} className={`flex items-center justify-center min-w-96 h-8 md:h-9 transition-all duration-700 ease-in-out ${scaleClass}`}>
                        {/* Conditional rendering for the loader image */}
                        {colorStep === index ? (
                          // Show loaderSuccess when the text is green (just before moving up)
                          <img src={loaderSuccess} alt="success" className="w-6 mr-1 object-contain transition-all duration-100 ease-in-out" />
                        ) : (
                          // Show loaderGif only for the current active step
                          index === step && <img src={loaderGif} alt="loader" className="w-[40px] object-contain transition-all duration-700 ease-in-out" />
                        )}
                        <p className={`text-sm md:text-lg font-extrabold transition-all duration-700 ease-in-out ${opacityClass} ${textColorClass}`}>{item.name}</p>
                      </div>
                    );
                  })}
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
};
